const getTag = (tagsMap, name) => {
  if (!tagsMap.get(name)) {
    tagsMap.set(name, { entries: [], tag: { name } });
  }
  return tagsMap.get(name);
};
export {
  getTag
};
//# sourceMappingURL=get-tag.js.map
